<template>
  <div class="lc-actions">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon small v-on="on" @click.stop="$emit('preview', payslip)">
          <v-icon small color="blue">mdi-file-pdf-box</v-icon>
        </v-btn>
      </template>
      <span>Ver recibo</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon small v-on="on" @click.stop="$emit('events', payslip)">
          <v-icon small color="grey darken-1">mdi-history</v-icon>
        </v-btn>
      </template>
      <span>Historial</span>
    </v-tooltip>

    <!-- El resto de las acciones, segun el estado del recibo -->
    <v-menu v-if="menuActions.length > 0" offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
          <v-icon small class="grey--text text--darken-2">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item v-for="action in menuActions" :key="action.event" @click="$emit(action.event, payslip)">
          <v-list-item-icon class="mr-3">
            <v-icon small :color="action.color">{{ action.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :class="action.text_class">{{ action.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Mantiene el ancho de la columna cuando no hay menu -->
    <span v-else class="actions-spacer"></span>
  </div>
</template>

<script>
import { PAYSLIP_STATUS_DRAFT, PAYSLIP_STATUS_VOIDED, PAYSLIP_STATUS_SIGNED } from "@/constants/payslips";

export default {
  props: {
    payslip: Object,
    update_access: Boolean,
  },
  computed: {
    menuActions() {
      const payslip = this.payslip;
      const actions = [];
      if (payslip.status == PAYSLIP_STATUS_SIGNED)
        actions.push({ event: "signature", name: "Ver firma", icon: "mdi-check-decagram", color: "green" });
      if (!this.update_access) return actions;

      if (payslip.can_publish) actions.push({ event: "publish", name: "Publicar", icon: "mdi-send", color: "primary" });
      if (payslip.status == PAYSLIP_STATUS_DRAFT && payslip.scheduled_publish_at)
        actions.push({ event: "cancel-schedule", name: "Cancelar programación", icon: "mdi-calendar-remove", color: "purple" });
      if (payslip.status == PAYSLIP_STATUS_DRAFT)
        actions.push({ event: "assign", name: "Asignar legajo", icon: "mdi-account-arrow-right", color: "green" });
      if (payslip.status != PAYSLIP_STATUS_VOIDED)
        actions.push({ event: "void", name: "Anular / reemplazar", icon: "mdi-cancel", color: "red", text_class: "red--text" });
      return actions;
    },
  },
};
</script>

<style scoped>
.actions-spacer {
  display: inline-block;
  width: 28px;
}
</style>
